/* eslint-disable react/forbid-dom-props */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * 鼠标hover时展开下拉
 */
class Hoverdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      firstTimeClicked: false,
    };

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.closeInAWhile = this.closeInAWhile.bind(this);
    this.toggle = this.toggle.bind(this);
    this.wrapperChange = (ref) => (this.wrapperRef = ref);
    this.wrapperRef = null;
    this.documentClickHandler = this.documentClickHandler.bind(this);
  }

  documentClickHandler(ev) {
    if (
      this.props.isMutableDom ||
      // 只有点击菜单的时候才不做处理
      (this.wrapperRef && this.wrapperRef.contains(ev.target))
    ) {
      return;
    }
    this.close();
  }

  addDocumentClickListener() {
    if (!this.wrapperRef) {
      setTimeout(() => {
        this.addDocumentClickListener();
      });
    } else {
      document.addEventListener('click', this.documentClickHandler);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.documentClickHandler);
  }

  componentDidMount() {
    this.addDocumentClickListener();
  }

  open() {
    if (this.closingTimeout) {
      clearTimeout(this.closingTimeout);
    }
    this.props.onOpen();
    this.setState({ isOpen: true });
  }

  close() {
    this.setState({ isOpen: false, firstTimeClicked: false });
    this.props.onClose();
  }

  // Will close the hoverdown in 0.1s
  closeInAWhile() {
    const { closeTimeout } = this.props;
    this.closingTimeout = setTimeout(
      this.close,
      closeTimeout || closeTimeout === 0 ? closeTimeout : 200
    );
  }

  toggle() {
    const { firstTimeClicked } = this.state;

    if (firstTimeClicked) {
      return this.close();
    } else {
      this.setState({ firstTimeClicked: true });
      return this.open();
    }
  }

  render() {
    const {
      children: [header, menu],
      className,
      btnClassName,
      menuClassName,
      disabledHover,
    } = this.props;

    const { isOpen } = this.state;

    // 使用行内样式控制, 因为改变具有hidden属性的元素的CSS的 display 属性将覆盖该行为,会导致hidden属性不生效
    const menuProps = isOpen ? {} : { display: 'none' };

    return (
      <span
        className={`hoverdown ${className} ${isOpen ? 'open' : ''}`}
        onMouseEnter={!disabledHover && this.open}
        onMouseLeave={!disabledHover && this.closeInAWhile}
        ref={this.wrapperChange}
      >
        <div className={`hoverdown-btn ${btnClassName}`} onClick={this.toggle}>
          {header}
        </div>
        <div className={`hoverdown-menu ${menuClassName}`} style={menuProps}>
          {menu}
        </div>
      </span>
    );
  }
}

Hoverdown.propTypes = {
  className: PropTypes.string,
  btnClassName: PropTypes.string,
  menuClassName: PropTypes.string,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  /**
   * 关闭menu的延时
   */
  closeTimeout: PropTypes.number,
  /**
   * 是否禁用hover触发下拉菜单,如果禁用则使用点击触发
   */
  disabledHover: PropTypes.bool,
  /**
   * 注意，children的第一个元素固定位header，第二个元素固定位展开的body
   */
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  /**
   * 下拉菜单的 dom 是否是可变的（默认是不可变的）
   *
   * 由于 Hoverdown 的点击事件依赖当下 render 的 refs 以及触发 onClick 事件时的本体 dom
   * 可能会出现后者已经 !isInPage
   * 当 Hoverdown 的菜单是可变化/可切换的，此时应该传入 isImmutableDom = false.
   * 以防止 Hoverdown 无故 close.
   */
  isMutableDom: PropTypes.bool,
};

Hoverdown.defaultProps = {
  className: '',
  btnClassName: '',
  menuClassName: '',
  onClose: () => {},
  onOpen: () => {},
  isMutableDom: false,
};

export default Hoverdown;
